<h2 class="modal-title">OTP Verification</h2>
<p class="modal-dec">Please enter the OTP to verify your account</p>
<form [formGroup]="verificationForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
        <input class="form-control" formControlName="otp" type='text' [imask]="{mask: '0 0 0 0 0 0',lazy:false}"
            [unmask]="true">
        @if((vf['otp'].invalid && vf['otp'].touched || submitted) || vf.otp.errors?.apiError) {
        @if (vf.otp.errors?.required){
        <span class="required-message">Please enter verification code</span>
        }
        @if (vf.otp.errors?.apiError){
        <span class="required-message">{{vf.otp.errors?.apiError}}</span>
        }
        }
    </div>
    <div class="resend-otp">
        <span class="links" (click)="resendCode()"> Click here </span> to resend.
    </div>
    <div class="form-group">
        <button type="submit" class="btn btn-primary" [disabled]="verificationForm.invalid">
            <span class="btn-primary-hover"></span>
            <span class="btn-content">Confirm</span>
        </button>
    </div>
    <div class="form-group">
        <button type="button" class="btn btn-secondary" (click)="cancel()">
            <span class="btn-secondary-hover"></span>
            <span class="btn-content">Back</span>
        </button>
    </div>
</form>
